import { isEmbeddedIframe } from 'src/app/data/common/utils/isEmbeddedIframe';

/**
 * Returns cookie attributes (SameSite, secure, partitioned)
 *
 * - Non-embedded: SameSite 'Lax'
 * - Embedded iframe: SameSite 'None', secure (when https), partitioned
 */
export function getCookieOptions(): {
  SameSite: 'Lax' | 'None';
  secure?: boolean;
  partitioned?: boolean;
} {
  const isEmbedded = isEmbeddedIframe();
  return Object.freeze({
    SameSite: isEmbedded ? 'None' : 'Lax',
    ...(typeof window !== 'undefined' && window.location.protocol === 'https:'
      ? { secure: true }
      : {}),
    ...(isEmbedded ? { partitioned: true } : {}),
  });
}
